module.exports = __webpack_public_path__ + "static/media/-3.7b0909f7.png";